module.exports = __webpack_public_path__ + "static/media/studies_img_three.2676251b.jpg";